import {Component, OnInit, Renderer2} from '@angular/core';
import {MatDateRangePicker} from "@angular/material/datepicker";
import {AbstractControl, FormBuilder, FormGroup} from "@angular/forms";
import {BalanceFormatterUtil} from "./balance-formatter-util ";
import {ActivityTabs} from '../../enums/activity-tabs';
import {SharedConstants} from '../../utilityClass/sharedConstants';
import {TransactionAndTransferInfoModel} from '../../models/transactionAndTransferInfo.model';
import {PaymentTransactionsResponse} from "../../models/paymentTransactions .model";
import {UserResponse} from "../../interface/userResponse";
import {Team} from "../../interface/team";
import {PaymentTransactionFilterModel} from "../../interface/paymentTransactionFilterModel ";
import {TransactionService} from "../../service/transaction.service";
import {UserService} from "../../service/user.service";
import {TeamService} from "../../service/team.service";
import {UserShortResponse} from "../../interface/userShortResponse";
import {ALLOWED_KEYS} from "../../constants/deleteProfileCards.constant";
import {Page} from "../../interface/hashtag";
import {DatePipe} from "@angular/common";
import {GetPageUtil} from "../get-page-util";
import {SnackBarUtil} from "../../qr-copy-message/snack-bar-util.service";
import {MockupType} from "../../qr-copy-message/mockup-type.enum";
import {QrCopyMessageComponent} from "../../qr-copy-message/qr-copy.component";
import {MockupDataModel} from "../../qr-copy-message/mockup-data.model";
import {MatSnackBar} from "@angular/material/snack-bar";
import {TranslateService} from "@ngx-translate/core";
import {ActivityFilterFormValue, DEFAULT_ACTIVITY_FILTER_FORM_VALUE} from "../../interface/activityFilterFormValue";

@Component({
  selector: 'app-admin-activity',
  templateUrl: './admin-activity.component.html',
  styleUrl: './admin-activity.component.scss'
})
export class AdminActivityComponent implements OnInit {
  activeTab = ActivityTabs.ALL_INDIVIDUAL;
  selectedTab: string = SharedConstants.ALL;
  searchQuery: string = '';
  allPaymentTransactions: TransactionAndTransferInfoModel[] = []
  transactionsAndTransfers!: PaymentTransactionsResponse
  currentUser !: UserResponse
  currentTeam!: Team
  filterForm!: FormGroup;
  menuOpen = false
  private savedFilterFormValue: ActivityFilterFormValue = {...DEFAULT_ACTIVITY_FILTER_FORM_VALUE};
  isNewTransactions: boolean = false
  isNewRequests: boolean = false
  currency = SharedConstants.CURRENCY
  currentPage: number = 0;
  pageSize: number = 10;
  trimmedQuery!: string
  totalRecords: number = 0;
  totalPages: number = 0;
  filterPayload!: PaymentTransactionFilterModel | null
  isTeamsMenuOpen = false;
  isIndividualMenuOpen = false;
  teams: Team[] = []
  selectedTeam!: Team | null
  individualBalance!: number
  allTeamBalance!: number
  balance!: number
  isLoading: boolean = false;
  selectedTeamId = 0
  selectedUserId = 0
  users!: UserShortResponse[]
  selectedUser!: UserShortResponse | null
  filteredUsers: UserShortResponse[] = []
  filteredTeams: Team[] = []
  individualSearchQuery: string = ''
  teamSearchQuery: string = ''
  private getPageUtil = new GetPageUtil();

  protected readonly BalanceFormatterUtil = BalanceFormatterUtil;

  constructor(private transactionService: TransactionService,
              private teamService: TeamService,
              private userService: UserService,
              private fb: FormBuilder,
              private renderer: Renderer2,
              private snackBar: MatSnackBar,
              private translateService: TranslateService) {
  }

  ngOnInit(): void {
    this.getIndividualPaymentTransactions(0, this.currentPage, this.pageSize)
    this.getUsers()
    this.getAllTeams()
    this.filterForm = this.fb.group(
      {
        status: [''],
        amountFrom: [''],
        amountTo: [''],
        dateRange: this.fb.group({
          startDate: [null],
          endDate: [null]
        })
      },
      {validator: this.amountRangeValidator}
    );
  }

  amountRangeValidator(form: AbstractControl) {
    const amountFrom = form.get('amountFrom')?.value;
    const amountTo = form.get('amountTo')?.value;
    if (amountFrom !== 0 && amountTo > 0  && amountTo < amountFrom) {
      return { amountInvalid: true };
    }
    return null;
  }

  getIndividualPaymentTransactions(selectedUserId: number, currentPage: number, pageSize: number, trimmedQuery?: string) {
    if (selectedUserId) {
      this.getAllTransactions(selectedUserId, currentPage, pageSize, trimmedQuery)
    } else {
      this.transactionService.getAllIndividualPaymentTransactionsForSuperAdmin(currentPage, pageSize, trimmedQuery).subscribe(res => {
        this.individualBalance = res.balance
        this.updateTransactionData(res);
      })
    }
  }

  getUsers() {
    this.userService.getUsersForAdmin().subscribe(users => {
      this.users = users
      this.filteredUsers = users
    })
  }

  getAllTeams() {
    this.teamService.getAllTeams().subscribe(teams => {
      this.teams = teams
      this.filteredTeams = teams
    })
  }

  filterIndividuals() {
    const query = this.individualSearchQuery.trim().toLowerCase();
    if (!query) {
      this.filteredUsers = this.users;
    } else {
      this.filteredUsers = this.users.filter(user => {
        const fullName = `${user.name} ${user.surname}`.toLowerCase();
        const firstName = user.name.toLowerCase();
        const lastName = user.surname.toLowerCase();
        return fullName.includes(query) || firstName.includes(query) || lastName.includes(query);
      });
    }
  }

  filterTeams() {
    this.filteredTeams = this.filterList(
      this.teams,
      this.teamSearchQuery,
      team => team.name
    );
  }

  private filterList<T>(items: T[], query: string, getName: (item: T) => string): T[] {
    const trimmed = query.trim().toLowerCase();
    if (!trimmed) return items;

    return items.filter(item => {
      const name = getName(item).toLowerCase();
      return name.includes(trimmed);
    });
  }

  onIndividualMenuOpened() {
    this.toggleMenu(SharedConstants.ENTITY_TYPE_INDIVIDUAL, true);
  }

  onIndividualMenuClosed() {
    this.toggleMenu(SharedConstants.ENTITY_TYPE_INDIVIDUAL, false);
  }

  onTeamsMenuOpened() {
    this.toggleMenu(SharedConstants.ENTITY_TYPE_TEAM, true);
  }

  onTeamsMenuClosed() {
    this.toggleMenu(SharedConstants.ENTITY_TYPE_TEAM, false);
  }

  private toggleMenu(type: string, isOpen: boolean) {
    if (type === SharedConstants.ENTITY_TYPE_INDIVIDUAL) {
      this.isIndividualMenuOpen = isOpen;
      this.individualSearchQuery = '';
      this.filteredUsers = this.users;
    } else {
      this.isTeamsMenuOpen = isOpen;
      this.teamSearchQuery = '';
      this.filteredTeams = this.teams;
    }
  }

  selectTab(tab: string) {
    this.selectedTab = tab;
    this.resetTransactions();
    this.processFilterOrTransaction();
  }

  toggleIndividual(activeTab: string) {
    this.activeTab = activeTab as ActivityTabs;
    this.selectedTeamId = 0
    this.selectedUserId = 0
    this.selectedTeam = null
    this.selectedUser = null
    if (activeTab === ActivityTabs.ALL_TEAMS) {
      this.isTeamsMenuOpen = !this.isTeamsMenuOpen
    } else {
      this.isIndividualMenuOpen = !this.isIndividualMenuOpen
    }
    this.resetTransactions();
    this.selectedTab = SharedConstants.ALL
    this.handlePaymentTransaction(this.currentPage, this.pageSize)
  }

  resetDateRange(picker: MatDateRangePicker<any>) {
    this.filterForm.get('dateRange')?.reset()
    picker.close();
  }

  filter() {
    if (this.filterForm.dirty) {
      const formData = this.filterForm.value;
      this.savedFilterFormValue = formData;
      this.filterPayload = {
        status: formData.status ? formData.status : null,
        amountFrom: formData.amountFrom,
        amountTo: formData.amountTo,
        startDate: this.formatDate(formData.dateRange.startDate),
        endDate: this.formatDate(formData.dateRange.endDate),
        selectedTab: this.selectedTab
      };
      if (this.activeTab === ActivityTabs.ALL_INDIVIDUAL) {
        this.filterIndividualTransactions();
      } else {
        this.filterTeamTransactions();
      }
    }
  }

  reset() {
    this.filterForm.reset()
    this.savedFilterFormValue = {...DEFAULT_ACTIVITY_FILTER_FORM_VALUE}
    this.filterPayload = null
    this.handlePaymentTransaction(this.currentPage, this.pageSize)
  }

  search() {
    this.trimmedQuery = this.searchQuery.trim();
    const isQueryValid = this.trimmedQuery.length > 2;
    const queryParam = isQueryValid ? this.trimmedQuery : undefined;
    this.resetTransactions();
    switch (this.activeTab) {
      case ActivityTabs.ALL_INDIVIDUAL:
        this.handleIndividualTab(this.currentPage, this.pageSize, queryParam);
        break;
      case ActivityTabs.ALL_TEAMS:
        this.handleAllTeamTab(this.currentPage, this.pageSize, queryParam);
        break;
    }
  }

  getLastFourDigits(accountNumber: string): string {
    if (accountNumber && accountNumber.length > 4) {
      return accountNumber.slice(-4);
    }
    return ""
  }

  onMenuOpened(): void {
    this.savedFilterFormValue = this.filterForm.value;
    const overlayContainer = this.renderer.selectRootElement('.cdk-overlay-container', true);

    if (overlayContainer) {
      this.renderer.setStyle(overlayContainer, 'z-index', '98');
    }
  }

  onMenuClosed(): void {
    this.filterForm.setValue(this.savedFilterFormValue);
    const overlayContainer = this.renderer.selectRootElement('.cdk-overlay-container', true);
    if (overlayContainer) {
      this.renderer.removeStyle(overlayContainer, 'z-index');
    }
  }

  selectTeam(team: Team) {
    this.selectEntity(team, SharedConstants.ENTITY_TYPE_TEAM);
  }

  selectUser(user: UserShortResponse | null) {
    this.selectEntity(user, SharedConstants.ENTITY_TYPE_USER);
  }

  selectTeamFromDropdown(team: Team | null) {
    this.selectEntity(team, SharedConstants.ENTITY_TYPE_TEAM);
  }

  private selectEntity<T extends UserShortResponse | Team>(
    entity: T | null,
    type: string
  ) {
    if (type === SharedConstants.ENTITY_TYPE_USER) {
      this.selectedUser = entity as UserShortResponse | null;
      this.selectedUserId = entity ? Number((entity as UserShortResponse).id) : 0;
      this.isIndividualMenuOpen = false;
      this.resetTransactions();
      this.selectedTab = SharedConstants.ALL;
      this.processFilterOrTransaction();
    } else {
      this.selectedTeam = entity as Team | null;
      this.selectedTeamId = entity ? (entity as Team).id : 0;
      this.isTeamsMenuOpen = false;
      this.resetTransactions();
      this.selectedTab = SharedConstants.ALL;
      if (entity) {
        this.activeTab = ActivityTabs.ALL_TEAMS;
      }
      this.handleAllTeamTab(this.currentPage, this.pageSize, this.trimmedQuery);
    }
  }

  calculateCommission(row: TransactionAndTransferInfoModel): number | null {
    if (row.commissionUnit === 'PERCENT') {
      return row.userCardCommission ?? null;
    }
    return row.standardCommission ?? null;
  }

  getCommissionSymbol(commissionUnit: string | null): string {
    return commissionUnit === 'PERCENT' ? '%' : String(this.currency);
  }

  calculateExtraCommission(row: TransactionAndTransferInfoModel): number | null {
    return row.extraCommission ?? null;
  }

  calculateAmount(transferInfoModel: TransactionAndTransferInfoModel): number {
    if (transferInfoModel.paymentMethod === SharedConstants.TRANSFER) {
      return transferInfoModel.amount;
    }
    if (transferInfoModel.totalAmount != null) {
      return transferInfoModel.totalAmount;
    }
    const commission = transferInfoModel.userCardCommission ?? transferInfoModel.commission ?? 0;
    return commission
      ? transferInfoModel.amount + transferInfoModel.amount * commission / 100
      : transferInfoModel.amount;
  }

  goToPage(page: number) {
    if (page >= 0 && page < this.totalPages) {
      this.currentPage = page;
      this.processFilterOrTransaction()
    }
  }

  getPageNumbers(): number[] {
    return this.getPageUtil.getPageNumbers(this.currentPage, this.totalRecords, this.pageSize);
  }

  allowOnlyNumbers(event: KeyboardEvent): void {
    if (!ALLOWED_KEYS.test(event.key)) {
      event.preventDefault();
    }
  }

  updateStatus(transfer: TransactionAndTransferInfoModel) {
    this.transactionService.changeRequestStatus(transfer.id, transfer.paymentStatus).subscribe(_=>{
      if (transfer.paymentStatus == SharedConstants.COMPLETED){
        this.balance = this.balance - transfer.amount
      }
    })
  }

  formatDate(date: Date): string | null {
    if (!date) return null;

    const datePipe = new DatePipe('en-US');
    return datePipe.transform(date, 'dd.MM.yyyy');
  }

  resetTransactions(): void {
    this.allPaymentTransactions = [];
    this.currentPage = 0;
  }

  copyCode(accountNumber: string): void {
      navigator.clipboard.writeText(accountNumber).then(
        () => {
          this.showSnackbar('Successfully copied.', SnackBarUtil.CLASSES.success, MockupType.SUCCESS);
        }
      );
  }

  private showSnackbar(message: string, panelClassNames: string[], type: MockupType): void {
    this.snackBar.openFromComponent(QrCopyMessageComponent, {
      duration: 5000,
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: panelClassNames,
      data: new MockupDataModel(message, type),
    });
  }

  private filterIndividualTransactions() {
    if (this.filterPayload) {
      this.transactionService
        .filterAllUsersIndividualPaymentTransactions(this.filterPayload, this.currentPage, this.pageSize, this.selectedUser?.id)
        .subscribe(transactions => {
          this.processTransactionResults(transactions);
        });
    }
  }

  private filterTeamTransactions() {
    if (this.filterPayload) {
      this.transactionService.filterAllTeamsIndividualPaymentTransactions(this.filterPayload, this.currentPage, this.pageSize, this.selectedTeam?.id).subscribe(transactions => {
        this.processTransactionResults(transactions);
      })
    }
  }

  private processFilterOrTransaction() {
    if (this.filterForm.dirty) {
      this.filter();
    } else {
      this.handlePaymentTransaction(this.currentPage, this.pageSize, this.trimmedQuery);
    }
  }

  private updateTransactionData(res: PaymentTransactionsResponse): void {
    this.transactionsAndTransfers = res;
    this.totalRecords = res.allTransactions.totalElements;
    this.balance = res.balance;
    this.allPaymentTransactions = res.allTransactions.content;
    this.totalPages = res.allTransactions.totalPages;
    this.isNewTransactions = res.isAdminSeen
    this.isNewRequests = res.requestIsAdminSeen
  }

  private handlePaymentTransaction(currentPage: number, pageSize: number, trimmedQuery?: string): void {
    if (this.activeTab === ActivityTabs.ALL_INDIVIDUAL) {
      this.handleIndividualTab(currentPage, pageSize, trimmedQuery);
    } else if (this.activeTab === ActivityTabs.ALL_TEAMS) {
      this.handleAllTeamTab(currentPage, pageSize, trimmedQuery);
    }
  }

  private handleIndividualTab(currentPage: number, pageSize: number, trimmedQuery?: string) {
    if (this.filterPayload) {
      this.filter();
    } else {
      switch (this.selectedTab) {
        case SharedConstants.ALL:
          this.getIndividualPaymentTransactions(Number(this.selectedUser?.id), currentPage, pageSize, trimmedQuery)
          break;
        case SharedConstants.INCOMING:
          this.isNewTransactions = false
          this.transactionService.changeTransactionsIsAdminSeen(this.selectedUser?.id).subscribe()
          this.getIncomingTransactions(this.selectedUser?.id, currentPage, pageSize, trimmedQuery);
          break;
        case SharedConstants.BALANCE_TRANSFER:
          this.isNewRequests = false
          this.transactionService.changeRequestsIsAdminSeen(this.selectedUser?.id).subscribe()
          this.getRequestsTransfers(this.selectedUser?.id, currentPage, pageSize, trimmedQuery)
          break;
      }
    }
  }

  private handleAllTeamTab(currentPage: number, pageSize: number, trimmedQuery?: string) {
    if (this.filterPayload) {
      this.filter();
    } else {
      switch (this.selectedTab) {
        case SharedConstants.ALL:
          this.getTransactionsForTeam(this.selectedTeam?.id, currentPage, pageSize, trimmedQuery)
          this.totalRecords = this.transactionsAndTransfers.allTransactions.totalElements
          break;
        case SharedConstants.INCOMING:
          this.isNewTransactions = false
          this.transactionService.changeTeamsTransactionsIsAdminSeen(this.selectedUser?.id).subscribe()
          this.getIncomingTransactionsForTeam(this.selectedTeam?.id, currentPage, pageSize, trimmedQuery);
          break;
        case SharedConstants.BALANCE_TRANSFER:
          this.isNewRequests = false
          this.transactionService.changeTeamsRequestsIsAdminSeen(this.selectedTeam?.id).subscribe()
          this.getTeamsRequestsTransfersForSelectedTeam(this.selectedTeam?.id, currentPage, pageSize, trimmedQuery)
          break;

      }
    }
  }

  private getAllTransactions(id: number, currentPage: number, pageSize: number, trimmedQuery?: string) {
    this.transactionService.getAllIndividualPaymentTransactions(id, currentPage, pageSize, trimmedQuery).subscribe({
      next: (transactions) => {
        this.individualBalance = transactions.balance
        this.updateTransactionData(transactions)
      },
      error: (error) => this.handleTransactionError(error),
    })
  }

  private getTransactionsForTeam(teamId: number | undefined, currentPage: number, pageSize: number, trimmedQuery?: string) {
    this.transactionService.getAllTeamsPaymentTransactions(teamId, currentPage, pageSize, trimmedQuery).subscribe({
      next: (transactions) => {
        this.allTeamBalance = transactions.balance;
        this.updateTransactionData(transactions);
      },
      error: (error) => this.handleTransactionError(error),
    });
  }

  private getRequestsTransfers(selectedUserId: bigint | undefined, currentPage: number, pageSize: number, trimmedQuery?: string) {
    const requestObservable = selectedUserId
      ? this.transactionService.getRequestsTransfers(selectedUserId, currentPage, pageSize, trimmedQuery)
      : this.transactionService.getRequestsTransfersForSuperAdmin(currentPage, pageSize);

    requestObservable.subscribe({
      next: (transactions) => {
        this.processTransactionResults(transactions);
      },
      error: (error) => this.handleTransactionError(error),
    });
  }

  private handleTransactionError(error: any): void {
    console.error('Error fetching transactions:', error);
  }

  private getTeamsRequestsTransfersForSelectedTeam(selectedTeamId: number | undefined, currentPage: number, pageSize: number, trimmedQuery?: string) {
    this.transactionService.getTeamsRequestsTransfersForSuperAdmin(selectedTeamId, currentPage, pageSize).subscribe(transactions => {
      this.processTransactionResults(transactions)
    })
  }

  private processTransactionResults(transactions: Page<TransactionAndTransferInfoModel>): void {
    this.totalRecords = transactions.totalElements;
    this.allPaymentTransactions = transactions.content;
    this.totalPages = transactions.totalPages;
  }

  private getIncomingTransactions(selectedUserId: bigint | undefined, currentPage: number, pageSize: number, trimmedQuery?: string) {
    const requestObservable = selectedUserId
      ? this.transactionService.getIncomingTransactions(selectedUserId, currentPage, pageSize, trimmedQuery)
      : this.transactionService.getIncomingTransactionsForSuperAdmin(currentPage, pageSize, trimmedQuery);

    requestObservable.subscribe({
      next: (transactions) => {
        this.processTransactionResults(transactions);
      },
      error: (error) => this.handleTransactionError(error),
    });
  }

  private getIncomingTransactionsForTeam(teamId: number | undefined, currentPage: number, pageSize: number, trimmedQuery?: string) {
    this.transactionService.getIncomingTransactionsForSelectedTeamByTeamId(teamId, currentPage, pageSize, trimmedQuery).subscribe({
      next: (transactions) => {
        this.processTransactionResults(transactions)
      },
      error: (error) => this.handleTransactionError(error),
    })
  }

 formatPaymentMethod(paymentMethod: string): string {
    if (!paymentMethod) return '-';
    return paymentMethod
      .replace(/_/g, ' ')
      .toLowerCase()
      .replace(/\b\w/g, c => c.toUpperCase());
  }

  protected getStatusTranslation(status: string): string {
    switch (status) {
      case SharedConstants.REJECTED:
        return this.translateService.instant('payment_status.rejected');
      case SharedConstants.COMPLETED:
        return this.translateService.instant('payment_status.completed');
      case SharedConstants.PENDING:
        return this.translateService.instant('payment_status.pending');
      default:
        return status;
    }
  }

  protected readonly SharedConstants = SharedConstants;
  protected readonly ActivityTabs = ActivityTabs;
  protected readonly Number = Number;
}
